var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16669 3.33335C5.94503 3.33335 3.33335 5.94503 3.33335 9.16669C3.33335 12.3883 5.94503 15 9.16669 15C12.3883 15 15 12.3883 15 9.16669C15 5.94503 12.3883 3.33335 9.16669 3.33335ZM1.66669 9.16669C1.66669 5.02455 5.02455 1.66669 9.16669 1.66669C13.3088 1.66669 16.6667 5.02455 16.6667 9.16669C16.6667 13.3088 13.3088 16.6667 9.16669 16.6667C5.02455 16.6667 1.66669 13.3088 1.66669 9.16669Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5775 13.5775C13.9029 13.252 14.4305 13.252 14.756 13.5775L18.0893 16.9108C18.4147 17.2362 18.4147 17.7639 18.0893 18.0893C17.7639 18.4147 17.2362 18.4147 16.9108 18.0893L13.5775 14.756C13.252 14.4305 13.252 13.9029 13.5775 13.5775Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.c39f71e1ae272b158a6d98d9bd3ccf4b.svg";
export { ForwardRef as ReactComponent };